// import React from "react"
import { cryptoOrders, wallet, productData, cryptoOrderData, icoLandingTeam, blogs, wallets, orderbookData, cryptoDeposits, cryptoHowitwork, cryptoMyAssets } from "./crypto"
import { invoiceList } from "./invoices"
import { projects, projectListData, OverviewTeamMember, projectAssignedTo } from "./projects"
import { tasks, kanbanBoardData, AddTeamMember, recentTasksData } from "./tasks"
import { mailDB, labelsData, mailChatData } from "./mails"
import { comments, customerData, discountData, orders, productsData, recentProducts, shops, productComments, productListvar } from "./ecommerce"
import { chats, contacts, groups, messages } from "./chat"
import { calenderDefaultCategories, events } from "./calender"
import { users, userProfile } from "./contacts"
import { dashboardEmail, latestTransaction } from "./dashboard"
import { myFiles, recentFile } from "./file-manager";

import { TopSellingData, dashboardEarning, chatData, tasksData, saasReports } from "./dashboard-saas"

import { jobVacancy, statisticsApplications, activityFeedData, recentAddedJobsData, chartsData } from "./dashboard-job";

import { jobs, jobListCandidate, jobApply } from "./job";
import { walletOptions, transactionsDataALL, transactionsDataSell, transactionsDataBuy, notificationsData, cryptoReports } from "./dashboard-crypto";
import { blogStatsData, visitor, postRecentData, postPopularData, commentsData, progressData, activityData, blogPost } from './dashboard-blog';
import { categoriesData, archiveData, popularPosts, tagsData } from "./blog";
import { jobsGridData, experienceData, jobType } from "./job-Grid";

export {
  recentTasksData,
  jobsGridData,
  experienceData,
  jobType,
  categoriesData,
  archiveData,
  popularPosts,
  tagsData,
  AddTeamMember,
  labelsData,
  mailChatData,
  mailDB,
  cryptoMyAssets,
  cryptoHowitwork,
  cryptoDeposits,
  orderbookData,
  recentAddedJobsData,
  chartsData,
  activityFeedData,
  statisticsApplications,
  activityData,
  blogPost,
  progressData,
  commentsData,
  postPopularData,
  postRecentData,
  visitor,
  blogStatsData,
  notificationsData,
  cryptoReports,
  transactionsDataSell,
  transactionsDataBuy,
  transactionsDataALL,
  walletOptions,
  tasksData,
  saasReports,
  productsData,
  discountData,
  events,
  calenderDefaultCategories,
  chats,
  groups,
  contacts,
  messages,
  orders,
  customerData,
  shops,
  recentProducts,
  comments,
  wallet,
  productData,
  cryptoOrderData,
  icoLandingTeam,
  blogs,
  cryptoOrders,
  wallets,
  invoiceList,
  projects,
  projectListData,
  OverviewTeamMember,
  projectAssignedTo,
  tasks,
  kanbanBoardData,
  users,
  userProfile,
  dashboardEmail,
  latestTransaction,
  TopSellingData,
  dashboardEarning,
  chatData,
  jobVacancy,
  productComments,
  productListvar,
  jobs,
  jobListCandidate,
  jobApply,
  myFiles,
  recentFile,
}
